/* export async function getAnagrams(word) {
  const url = `http://www.anagramica.com/all/:${word}`;

  try {
    const proxy = "https://corsproxy.io/?" + encodeURIComponent(url);
    const response = await fetch(proxy);
    console.log(response);
    const json = await response.json();

    return [word, json];
  } catch (err) {
    return [
      "GREETA",
      {
        all: ["GREAT", "GRATE", "GEAR", "RAGE", "RATE", "TEAR", "TEAR"],
      },
    ];
  }
}
 */

import anagramData from "../utils/anagramData";

export function getAnagrams() {
  const randomIndex = Math.floor(Math.random() * anagramData.length);
  const data = anagramData[randomIndex];
  return [data.word, { all: data.all }];
}

/* export async function getAnagrams(word) {
  const url = `http://www.anagramica.com/all/${word}`;

  try {
    const proxy = "https://corsproxy.io/?" + encodeURIComponent(url);
    
    const response = await fetch(proxy);

    console.log("Status:", response.status);

    // 403, 404, 500 etc. ko catch mein bhejo
    if (!response.ok) {
      throw new Error(`API failed with status ${response.status}`);
    }

    const json = await response.json();

    return [word, json];

  } catch (err) {
    console.error("Anagram API failed:", err);

    return [
      "GREETA",
      {
        all: ["GREAT", "GRATE", "GEAR", "RAGE", "RATE", "TEAR", "TEAR","TEA","GATE", "RAT","TREE"],
      },
    ];
  }
} */